import * as d3 from 'd3'

export default {
  methods: {

    draw_Values(selection, d_) {
      let cht = this.chart
      let tube = this.tube
      let base = this.base
      let title = this.title
      let col = this.columns

      let tubeChart = selection
      .append('g')
      .attr('transform', `translate(.5, .5)`)

      // Cumulative
      let data = col.find(f=> f.code == 'A_CUM')
      tubeChart
      .append('text')
      .attr('transform', `translate(${tube.tickness/2},${tube.height + base.textY + data.tSize*0.36})`)
      .style('font-size', data.tSize).style('font-weight', 400)
      .attr('fill', d_.A_CUM == 0 ? '#757575': data.tColor)
      .attr('text-anchor', 'middle')
      .text(`${d_.A_CUM}%`)

      // Weekly
      data = col.find(f=> f.code == 'A_WK')
      tubeChart
      .append('text')
      .attr('id', `TOTAL_${this.localId}`)
      .attr('transform', `translate(${tube.tickness/2},${cht.scale(100) + data.tSize*0.26})`)
      .style('font-size', data.tSize)
      .attr('fill', d_.A_WK == 0 ? '#757575': data.tColor)
      .attr('text-anchor', 'middle')
      .text(`${d_.A_WK}%`)

    },

  }
}